import { connectorApiClient } from '@/shared/api/core/axios-instance';

import type { CreateConnectorRequest, CreateConnectorResponse } from '@/entities/connector/types';

export const createConnectorApi = async (request: CreateConnectorRequest): Promise<CreateConnectorResponse> => {
  const { data } = await connectorApiClient.post<CreateConnectorResponse>('/connectors', request);
  return data;
};
